import axios from 'axios';
import NovelCovid from 'novelcovid';
import {
          SET_USER_COUNTRY, 
          SET_COUNTRIES, 
          LOADING_DATA,
          STOP_LOADING
         } from '../types';

/*
export const handleDrawerToggle = () => (dispatch) => {
    dispatch({ type: HANDLE_DRAWER_TOGGLE });   
}
*/

const track = new NovelCovid();

export const getUserCountry = () => (dispatch) => {
	axios    
       .get('https://extreme-ip-lookup.com/json/')
        .then(response => {
            dispatch({ type: SET_USER_COUNTRY,
                       payload: response.data.country
                     })
         })
         .catch((data, status) => {
            console.log('Request failed');
         }) 
}

/*
export const getAllCountries = () => (dispatch) => {
   dispatch({type: LOADING_DATA})
  axios.get("https://corona.lmao.ninja/v2/countries")
      .then((data) => {
        const allCountries = data.sort((a, b) => parseInt(a.cases) < parseInt(b.cases) ? 1 : -1);
         dispatch({type: SET_COUNTRIES, payload: allCountries})
      })
      .catch(err => {
        console.log(err)
      })
        

        
}

*/